import { useEffect, useState } from 'react';
import Checkbox from '@/Components/Checkbox';
import GuestLayout from '@/Layouts/GuestLayout';
import InputError from '@/Components/InputError';
import PrimaryButton from '@/Components/PrimaryButton';
import TextInput from '@/Components/TextInput';
import {Head, Link, useForm, router, usePage} from '@inertiajs/react';
import IconLogin from '@/Icons/IconLogin';
import IconPassword from '@/Icons/IconPassword';
import ErrorModal from '@/Components/ErrorModal';


export default function Welcome({ status, canResetPassword }) {
    const { menuItems = [] } = usePage().props;

    const { data, setData, post, processing, errors, reset } = useForm({
        email: '',
        password: '',
        remember: false,
    });

    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        console.log(menuItems)
        return () => {
            reset('password');
        };
    }, []);

    const submit = (e) => {
        e.preventDefault();
        post(route('login'));
    };

    const [errorMessage, setErrorMessage] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);

    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            if (errors.email || errors.password) return;
            const globalError = errors.message || errors.error;
            if (globalError) {
                setErrorMessage(globalError);
                setShowErrorModal(true);
            }
        }
    }, [errors]);


    return (
        <GuestLayout>
            <Head title="Log in" />
            <ErrorModal
                show={showErrorModal}
                onClose={() => setShowErrorModal(false)}
                message={errorMessage}
            />
            <div className="w-full max-w-[600px]">
                <h1 className="text-gray-900 text-center mb-10 font-semibold text-xl lg:text-3xl">Prijava</h1>

                {status && <div className="mb-4 font-medium text-sm text-green-600">{status}</div>}

                <form onSubmit={submit} autoComplete="on">
                    <div className='mb-10'>
                        <TextInput
                            id="email"
                            type="email"
                            name="email"
                            value={data.email}
                            className="block w-full"
                            autoComplete="email"
                            isFocused={true}
                            onChange={(e) => setData('email', e.target.value)}
                            label="E - mail adresa"
                        />

                        <InputError message={errors.email} className="mt-2" />
                    </div>

                    <div className='relative'>

                        <TextInput
                            id="password"
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={data.password}
                            className="block w-full"
                            autoComplete="current-password"
                            onChange={(e) => setData('password', e.target.value)}
                            label="Lozinka"
                        />

                        <button
                            type='button'
                            className={"right-5 z-10 absolute bg-transparent border-none inline-block w-[18px] top-1/2 -translate-y-1/2 " + (showPassword ? "text-gray-400" : "text-gray-900")}
                            title={showPassword ? "Sakrij lozinku" : "Prikaži lozinku"}
                            onClick={() =>
                                setShowPassword((prev) => !prev)
                            }
                        >
                            <IconPassword/>
                        </button>
                    </div>
                    <div className='mb-10'>
                        <InputError message={errors.password} className="mt-2" />
                    </div>

                    {canResetPassword && (
                        <div className="text-end mb-10">
                            {menuItems.includes('register') && (
                                <Link
                                    href={route('register')}
                                    className="transition-all duration-300 text-sm text-primary-400 hover:text-primary-500 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-200 me-4"
                                >
                                    Registriraj se
                                </Link>
                            )}
                            <Link
                                href={route('password.request')}
                                className="transition-all duration-300 text-sm text-primary-400 hover:text-primary-500 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-200"
                            >
                                Zaboravljena lozinka?
                            </Link>
                        </div>
                    )}

                    <div className="block mb-10">
                        <label className="flex items-center">
                            <Checkbox
                                name="remember"
                                checked={data.remember}
                                onChange={(e) => setData('remember', e.target.checked)}
                                className="transition-all accent-primary text-primary focus:ring-primary-200"
                            />
                            <span className="ms-2 text-sm text-gray-600">Zapamti me</span>
                        </label>
                    </div>

                    <div className="flex items-center justify-center mb-10">
                        <PrimaryButton disabled={processing}>
                            <span className='mr-4'>Prijavi se</span>
                            <IconLogin className='inline-block w-[22px] relative z-10' />
                        </PrimaryButton>
                    </div>

                </form>
            </div>
        </GuestLayout>

    );

}
